export default __webpack_public_path__ + "static/media/943.3e240f58.png";